(async () => {
    const baseComponent = await import(window.theme.modules.baseComponent);
  
    customElements.define('list-counter', class extends baseComponent.default {
          
      render() {
        this.on('updateList', this._update.bind(this), false);
        this.on('listChange', this._update.bind(this), false);
        this._update();
      };

      _update() {
  const draftOrderId = localStorage.getItem('ActiveWL');
  if (draftOrderId) {
    $.ajax({
      url: 'https://app.crowdmerch.com.au/crowdmerch/homepage/getDraftOrderItems',
      method: 'POST',
      data: { draftOrderId: draftOrderId },
      success: (data) => {
        if (data.status === 'ok' && data.items.length > 0) {
          const wishList = data.items;
          const item_count = wishList.length;

          console.log('item_count', item_count);
          this.textContent = item_count;

          if (+item_count === 0) {
            this.setAttribute('empty', 'true');
            return;
          }

          if (this.hasAttribute('empty') && +item_count !== 0) {
            this.removeAttribute('empty');
          }
        } else {
          // Handle empty or failed response
          this.textContent = 0;
          this.setAttribute('empty', 'true');
        }
      },
      error: () => {
        // Optional: Handle AJAX error
        this.textContent = 0;
        this.setAttribute('empty', 'true');
      }
    });
  } else {
    // No draftOrderId — set count to 0
    this.textContent = 0;
    this.setAttribute('empty', 'true');
  }
};

      
    });
  })();